import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const summaryUrl = createApiUrl('/api/search/admin-summary/')

const getSummary = async () => {
    const res = await axios.get(summaryUrl, tokenService.getAuthHeader())
    return res.data
}

const adminService = { getSummary }

export default adminService
